import { createSlice } from '@reduxjs/toolkit';
import { MediaManagerBoard, MediaManagerTemplate } from 'modules/manager/domain/interfaces';
import { createFetchBoardForEditorReducer, createFetchBoardOnlyReducer, createSaveBoardReducer } from './reducers';

export interface ManagerSliceState {
  activeTemplate: MediaManagerTemplate | null;
  activeBoard: MediaManagerBoard | null;
  isLoading: boolean;
  isLoaded: boolean;
  isSaving: boolean;
  error: string | null;
}

const initialState: ManagerSliceState = {
  activeTemplate: null,
  activeBoard: null,
  isLoading: false,
  isLoaded: false,
  isSaving: false,
  error: null,
};

export const managerSlice = createSlice({
  name: 'manager',
  initialState,
  reducers: {
    resetEditor() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    createFetchBoardForEditorReducer(builder);
    createFetchBoardOnlyReducer(builder);
    createSaveBoardReducer(builder);
  },
});

export const { resetEditor } = managerSlice.actions;
export default managerSlice.reducer;
